// import * as dayjs from 'dayjs';
import dayjs from 'dayjs';

export const ShortDateFromTimestamp = (timestamp: number) => dayjs.unix(timestamp).format('D MMM YYYY');

export const ShortDateFromFullDateTime = (fulldatetime: string) => dayjs(fulldatetime, 'M/D/YYYY hh:mm:ss A').format('D MMM YYYY');

export const RecentlySoldTimestampLimit = (soldDayLimit = 90, fromDate = new Date()) => {
    const priorTimestamp = (new Date(new Date().setDate(fromDate.getDate() - soldDayLimit))).getTime() / 1000;
    return priorTimestamp;
};

export default { ShortDateFromTimestamp, ShortDateFromFullDateTime };
